export default function (obj) {
  // This looks evil, but apparently it's arguably the most efficient way to deep copy in JavaScript.
  // Ghost help me.
  return JSON.parse(JSON.stringify(obj))
}



// WEBPACK FOOTER //
// ./src/helper/deepCopy.js